<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import notificationMixin from 'src/mixins/notificationMixin'
import masterMixin from 'src/mixins/masterMixin'
import baseApi from 'src/apis/masters/base'

const api = baseApi
const displayPageName = '基本台帳'
const msgVars = { import: '取込み' }

export default {
  displayPageName: displayPageName,
  data() {
    return {
      displayPageName: displayPageName,

      isReady: false,
      isRequesting: false,
      isImporting: false,

      list: [],
      uploadedFile: null,
      showImportModal: false,

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    hasList() {
      return this.list.length > 0
    },
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.list.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }

    await this.getList()
    this.isReady = true
  },
  mixins: [notificationMixin, masterMixin],
  methods: {
    async getList() {
      this.isRequesting = true
      try {
        const { data } = await api.index()
        this.list = data
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    onFileUpload(evt) {
      const file = evt.target.files[0]
      if (!file) { return }
      this.uploadedFile = file
      // 同一ファイル選択時にイベントが発火するよう初期化
      evt.target.value = ''
    },
    async importFile() {
      if (!this.uploadedFile) { return }

      this.isImporting = true
      const opType = 'import'
      try {
        const formData = new FormData()
        formData.append('csv', this.uploadedFile, this.uploadedFile.name)
        const reqObj = formData
        await api[opType](reqObj)
        await this.getList()
        this.closeImportModal()
        this.notifySuccess1(`${displayPageName}を${msgVars[opType]}ました`)
        this.isImporting = false
      } catch (err) {
        const msg = `${displayPageName}の${msgVars[opType]}に失敗しました。` +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
        this.isImporting = false
      }
    },
    closeImportModal() {
      this.uploadedFile = null
      this.showImportModal = false
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
